
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-orange-600 to-orange-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/a2998240-751c-41d3-bad2-d3267e63c20f.png" 
              alt="Brooklyn Auto Body Shop" 
              className="h-10 sm:h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/90 text-sm mb-6 leading-relaxed">
              Serving Brooklyn for over 30 years with expert auto repair, collision services, and maintenance. Your trusted partner for quality work.
            </p>
            <div className="flex gap-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a
                href="https://google.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="Google"
              >
                <i className="ri-google-fill text-lg"></i>
              </a>
              <a
                href="https://yelp.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white/10 transition-colors cursor-pointer"
                aria-label="Yelp"
              >
                <i className="ri-yelp-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-white/90 hover:text-white text-sm transition-colors">
                  Collision Repair
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white text-sm transition-colors">
                  Auto Body Painting
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white text-sm transition-colors">
                  Dent Removal
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white text-sm transition-colors">
                  Frame Straightening
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white text-sm transition-colors">
                  24/7 Towing Service
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/90 hover:text-white text-sm transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white text-sm transition-colors">
                  All Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-white/90 hover:text-white text-sm transition-colors">
                  Before & After Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/90 hover:text-white text-sm transition-colors">
                  Get Free Estimate
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base sm:text-lg mb-4">Visit Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-white/90">
                <i className="ri-map-pin-fill text-lg mt-0.5 flex-shrink-0"></i>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=4001+2nd+Avenue+Brooklyn+NY+11232"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  4001 2nd Avenue<br />Brooklyn, NY 11232
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/90">
                <i className="ri-phone-fill text-lg flex-shrink-0"></i>
                <a href="tel:+16319337887" className="hover:text-white transition-colors">
                  (631) 933-7887
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/90">
                <i className="ri-mail-fill text-lg flex-shrink-0"></i>
                <a href="mailto:info@collisionexpertsnyc.com" className="hover:text-white transition-colors break-all">
                  info@collisionexpertsnyc.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/90">
                <i className="ri-time-fill text-lg mt-0.5 flex-shrink-0"></i>
                <span>Mon-Fri: 8AM-6PM<br />Sat: 9AM-3PM<br />Sun: Closed</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/80">
            <p className="text-center sm:text-left">&copy; 2025 Brooklyn Auto Body Shop. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
